// extracted by mini-css-extract-plugin
export var authorDescription = "styles-mod--author-description--219ef";
export var authorImg = "styles-mod--author-img--4f4f5";
export var authorInfo = "styles-mod--author-info--09a12";
export var authorName = "styles-mod--author-name--49733";
export var authorPosition = "styles-mod--author-position--11f7c";
export var authorSocialMedia = "styles-mod--author-social-media--f9df3";
export var headAuthorImg = "styles-mod--head-author-img--f8957";
export var headAuthorName = "styles-mod--head-author-name--b3b0a";
export var headRecipeAuthor = "styles-mod--head-recipe-author--cdd3c";
export var recipeAuthor = "styles-mod--recipe-author--62c99";
export var recipePageBox = "styles-mod--recipe-page-box--fb7ef";
export var socialIcons = "styles-mod--social-icons--507c3";